var _path, _path2, _path3, _rect, _path4, _path5, _rect2, _path6, _path7, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 38,
    viewBox: "0 0 45 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.544V37.0879H2.55682H5.11364V20.6044V4.12088H7.51704H9.92071L14.6122 7.4149C17.1928 9.22685 19.4461 10.9189 19.6197 11.1752C19.8399 11.5001 19.9368 12.8755 19.9393 15.7108L19.9432 19.7802H22.5H25.0568L25.0607 15.7108C25.0632 12.8755 25.1601 11.5001 25.3803 11.1752C25.5539 10.9189 27.8072 9.22685 30.3878 7.4149L35.0793 4.12088H37.483H39.8864V20.6044V37.0879H42.4432H45V18.544V0L38.9276 0.00247117L32.8551 0.00473798L27.7722 3.60824C24.9768 5.58997 22.6299 7.21154 22.557 7.21154C22.355 7.21154 20.7169 6.09354 16.2509 2.90769L12.1751 0H6.08753H0V18.544ZM9.46023 23.0518V37.0879H12.1449H14.8295V31.7277V26.3674L22.3082 26.422L29.7869 26.4766L29.8552 31.7823L29.9235 37.0879H32.4759H35.0284V23.059V9.03029L34.0527 9.61463C33.516 9.93626 32.3703 10.6164 31.5067 11.1264L29.936 12.0536L29.8616 17.1016L29.7869 22.1497L22.3082 22.2043L14.8295 22.2589L14.807 18.0834C14.7741 11.9367 14.8837 12.2555 12.2727 10.7093C11.0774 10.0014 9.95574 9.3307 9.77983 9.21882C9.52491 9.05666 9.46023 11.8516 9.46023 23.0518Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 37.2857V33.2679V29.25H22.4318H24.9886V33.2679V37.2857H22.4318H19.875Z",
    fill: "#FF5722"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 19.875V15.6429V13.6875L19.6875 11.25L22.5 12.375L25.3125 11.25L25.125 15.6429V19.875H22.5H19.875Z",
    fill: "#FF5722"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 5.25,
    height: 37.125,
    fill: "#FF5722"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.125H9.9375L19.6875 11.25L22.5 12.375V7.125L12.1749 0H0V4.125Z",
    fill: "#FF5722"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45 4.125H35.0625L25.3125 11.25L22.5 12.375V7.125L32.8251 0H45V4.125Z",
    fill: "#FF5722"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.75,
    width: 5.25,
    height: 37.125,
    fill: "#FF5722"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5625 9L14.8125 12.1875V37.125H9.375V21L9.5625 9Z",
    fill: "#4CAF50"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0625 9L29.8125 12L29.625 37.125H35.0625V21V9Z",
    fill: "#4CAF50"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14.625,
    y: 22.1249,
    width: 15.375,
    height: 4.5,
    fill: "#4CAF50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.729795ce510288cb712ba7ba0c779411.svg";
export { ForwardRef as ReactComponent };